module.exports = __WEBPACK_EXTERNAL_MODULE_51__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"chai","commonjs":"chai","commonjs2":"chai","root":"chai"}
 ** module id = 51
 ** module chunks = 1 2
 **/